import apiClient from './apiClient';

export const announcementsApi = {
	getAll: async (orgId) => {
		const response = await apiClient.get(
			`/api/organizations/${orgId}/announcements`
		);
		return response.data;
	},

	getOne: async (id) => {
		const response = await apiClient.get(`/api/announcements/${id}`);
		return response.data;
	},

	create: async (announcementData) => {
		const response = await apiClient.post(
			`/api/announcements`,
			announcementData
		);
		return response.data;
	},

	update: async (announcementId, data) => {
		try {
			const response = await apiClient.patch(
				`/api/announcements/${announcementId}`,
				data
			);
			return response.data;
		} catch (error) {
			throw new Error(
				error.response?.data?.message || 'Failed to update announcement'
			);
		}
	},

	delete: async (id) => {
		const response = await apiClient.delete(`/api/announcements/${id}`);
		return response.data;
	},
};
